import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IErrorWarning } from '../../interfaces/error-warning';

@Component({
  selector: 'app-error-warning-dialog',
  templateUrl: './error-warning-dialog.component.html',
  styleUrls: ['./error-warning-dialog.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class ErrorWarningDialogComponent extends DialogContentBase {
  @Input() title: string = 'Errors and Warnings';
  @Input() issues: IErrorWarning[] = [];
  @Input() confirmText: string = 'Confirm and Schedule';
  @Input() cancelText: string = 'Go Back';

  constructor(dialogRef: DialogRef) {
    super(dialogRef);
  }

  onConfirm(): void {
    this.dialog.close('confirm');
  }

  onCancel(): void {
    this.dialog.close('cancel');
  }
}
